var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.question.media != '')?_c('img',{staticClass:"w-100",attrs:{"src":require('@/assets/' + _vm.question.media)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }